<template>
  <div class="privacy-policy">
    <div class="container">
      <h1>Política de privacidade The Media Trade</h1>

      <section class="policy-section">
        <p>
          Nós, da <strong>Media Trade Publicidade e Serviços Multidisciplinares Ltda.</strong>, estamos comprometidos em
          preservar sua privacidade. Neste documento esclarecemos quais dados são coletados dos usuários de nossos sites
          e respectivos serviços, assim como a forma que são utilizados. Alertamos que se você não concorda com o
          conteúdo desta política, não recomendamos utilizar nossos serviços, sites e plataformas.
        </p>

        <h2>Coleta de dados</h2>
        <p>Em nossos sites, as informações são coletadas das seguintes formas:</p>
        <p>1. <strong>Informações fornecidas por você</strong> - dados de identificação pessoal como nome, telefone,
          e-mail, empresa em que trabalha e cargo etc. Eventualmente, a solicitação algumas informações podem ser feitas
          por meio de contato direto feito por funcionários ou representantes da The Media Trade com os usuários via
          e-mail ou telefone.</p>
        <p>2. <strong>Informações de navegação no site</strong> - ao visitar nossos sites, são inseridos cookies no seu
          navegador por meio do software Google Analytics, quantificando seus padrões de navegação em nossos endereços.
          São coletadas, anonimamente, informações, como endereço IP, localização geográfica, fonte de referência, tipo
          de navegador, duração da visita e páginas visitadas.</p>
        <p>3. <strong>Histórico de contato</strong> - armazenamos informações a respeito de todos os contatos já
          realizados com nossos usuários, como conteúdos baixados a partir de nossas páginas e interações via e-mail,
          telefone e chat.</p>

        <h2>Uso de suas Informações Pessoais</h2>
        <p>O presente termo permite que a Media Trade utilize suas informações pessoais para diferentes finalidades.</p>
        <p>O e-mail é utilizado para trocas de conteúdos e informações referentes às suas interações através das nossas
          plataformas. Também pode ser usado para envio de comunicados, newsletters, oportunidades e ofertas sempre
          relacionadas aos temas: propaganda, publicidade e marketing.</p>
        <p>O usuário pode cancelar a assinatura a qualquer momento.</p>
        <p>Os dados de compras, upload e download poderão ser divulgados como pesquisas e estatísticas, não sendo
          reveladas abertamente nenhuma informação pessoal, a menos que seja autorizada pelo usuário.</p>
        <p>Funcionários da The Media Trade poderão eventualmente entrar em contato via e-mail ou telefone para fazer
          pesquisas ou apresentar produtos e serviços.</p>
        <p>Ao se cadastrar em nossos sites, o usuário recebe um e-mail de confirmação, juntamente com o termo de adesão
          que especifica as informações extras que serão solicitadas para a utilização dos nossos serviços.</p>

        <h2>Acesso às suas informações pessoais</h2>
        <p>Poderão ver suas informações pessoais apenas funcionários da The Media Trade, se e quando necessário, de
          acordo com a respectiva responsabilidade corporativa. Eventualmente, caso a inserção de suas informações se dê
          em ações criadas em parcerias, os parceiros explicitamente identificados também terão acesso à informação.
          Nenhuma informação pessoal poderá ser divulgada publicamente.</p>
        <p>A The Media Trade também se compromete a não vender, alugar ou repassar suas informações para terceiros. A
          única exceção está em casos em que essas informações forem exigidas judicialmente.</p>
        <p>Além disso, embora trabalhemos com boas práticas de proteção e segurança, nenhum serviço web possui 100% de
          garantia contra invasões e não podemos nos responsabilizar caso isso ocorra.</p>

        <h2>Compartilhamento de conteúdo nas redes sociais</h2>
        <p>Ao clicar nos botões de compartilhamento de conteúdo nas redes sociais disponíveis em nossas páginas, o
          usuário estará publicando o conteúdo por meio de seu perfil na rede selecionada. A Media Trade não tem acesso
          ao login e senha dos usuários nessas redes, nem publicará conteúdo em nome do usuário sem que ele realize esta
          ação.</p>

        <h2>Uso de informações fornecidas a nossos clientes</h2>
        <p>A The Media Trade disponibiliza a seus clientes ferramentas para planejamento de propaganda e publicidade,
          negociação com veículos de mídia, troca de arquivos em nuvem, gestão de marketing entre outras que envolvem o
          gerenciamento de informações quem seus clientes mantêm relacionamento.</p>
        <p>No entanto, a The Media Trade não controla as informações solicitadas utilizando seu sistema. Esses dados
          pertencem aos clientes, que os utilizam, divulgam e protegem de acordo com suas políticas de privacidade. São
          eles também os responsáveis por coletar, gerenciar e processar as informações confidenciais.</p>

        <h2>Cancelamento da assinatura e alteração/exclusão de informações pessoais</h2>
        <p>Você pode optar por não receber e-mails da The Media Trade.</p>
        <p>Em todos os e-mails que enviamos há sempre um link para cancelar a assinatura disponível nas últimas linhas.
          Ao clicar nesse link você será automaticamente descadastrado da lista.</p>
        <p>É importante mencionar que ao preencher qualquer formulário novamente, seja via e-mail ou diretamente em
          nossos sites, ficará caracterizada a reinserção do seu e-mail à lista. Portanto, a requisição de cancelamento
          deve ser feita novamente caso seja de seu interesse.</p>
        <p>Para alterar suas informações pessoais ou mesmo excluí-las do nosso banco de dados, basta enviar um e-mail
          para <strong><a href="mailto:contato@themediatrade.com">contato@themediatrade.com</a></strong>.</p>

        <h2>Mudanças na Política de Privacidade</h2>
        <p>Essa Política de Privacidade pode passar por atualizações. Desta forma, recomendamos visitar periodicamente
          esta página para que você tenha conhecimento sobre as modificações.</p>
        <p>Antes de usar informações para outros fins que não os definidos nesta Política de Privacidade, solicitaremos
          sua autorização.</p>

        <h2>Contato</h2>
        <p>Qualquer dúvida em relação à nossa política de privacidade pode ser esclarecida entrando em contato conosco
          através do e-mail <strong><a href="mailto:contato@themediatrade.com">contato@themediatrade.com</a></strong> ou
          telefones <strong><a href="tel:1143242739">11 4324-2739</a></strong> e <strong><a href="tel:11963929442">11
              96392-9442</a></strong>.</p>
        <p>Nossa sede está localizada na <strong>Rua Cláudio Soares, 72, Pinheiros, São Paulo/SP CEP 05422-030</strong>.
        </p>
      </section>
    </div>

    <v-footer dark>
      <v-container class="py-12" dark>
        <div class="d-flex justify-space-between mx-n4 pb-9  flex-wrap">
          <div class="px-4">
            <v-img src="@/assets/logo.svg" width="100"></v-img>
            <div class="text-p">
              © 2015-{{ year }} The Media Trade<br>23.659.903/0001-84<br>{{ $t('footer.copy') }}
            </div>
          </div>
          <div class="d-flex ma-3 flex-md-row flex-column">
            <div class="d-flex flex-column align-start">
              <div class="text-h6 mx-4">{{ $t('footer.company.title') }}</div>
              <v-btn text v-for="(item, index) in $t('footer.company.links')" :key="index" :href="item.link">{{
                item.text
              }}</v-btn>

            </div>
            <div class="d-flex flex-column align-start">
              <div class="text-h6 mx-4">{{ $t('footer.follow_us.title') }}</div>
              <v-btn text target="_blank" href="https://www.linkedin.com/company/media-trade"><v-icon
                  class="mr-2">mdi-linkedin</v-icon>LinkedIn <v-icon small
                  class="ml-6">mdi-arrow-top-right</v-icon></v-btn>
              <v-btn color="white" large class="mx-4 mt-9 primary--text" href="https://store.themediatrade.com"
                target="_blank">The Media Store <v-icon small class="ml-6">mdi-arrow-top-right</v-icon></v-btn>
            </div>
          </div>
        </div>
        <div class="mx-n4">
          <v-btn text small to="/politicas-de-cookie-e-privacidade">{{
            $t('footer.privacy') }}</v-btn>
          <v-divider vertical></v-divider>
          <v-btn text small to="/politicas-de-cookie-e-privacidade">{{
            $t('footer.terms') }}</v-btn>
        </div>
      </v-container>
    </v-footer>
  </div>


</template>

<script>
import moment from 'moment'

export default {
  name: 'PrivacyPolicy',
  metaInfo: {
    title: 'Política de Privacidade - The Media Trade',
    meta: [
      {
        name: 'description',
        content: 'Política de privacidade da The Media Trade - Saiba como coletamos, utilizamos e protegemos suas informações pessoais.'
      }
    ]
  },
  methods: {
    goToPage() {
      this.$router.push('/whitelabel')
      this.$nextTick(() => {
        window.scrollTo(0, 0)
      })
    }
  },
  mounted() {
    window.scrollTo(0, 0)
  },
  computed: {
    year(){
      return moment().format('Y')
    }
  }
}
</script>

<style scoped>
h1 {
  color: #333;
  text-align: left;
  margin-bottom: 2rem;
  font-size: 2.5rem;
}

.policy-section {
  margin-bottom: 2rem;
}

h2 {
  color: #2c3e50;
  border-bottom: 2px solid #3498db;
  padding-bottom: 0.5rem;
  margin-bottom: 1rem;
  font-weight: bold;
}

h3 {
  color: #34495e;
  margin-top: 1.5rem;
  margin-bottom: 0.5rem;
  font-weight: bold;
}

p,
li {
  line-height: 1.6;
  color: #555;
  margin-bottom: 1rem;
}

ol {
  padding-left: 1.5rem;
}

li {
  margin-bottom: 1rem;
}

strong {
  color: #2c3e50;
  font-weight: bold;
}

a {
  color: #3498db;
  text-decoration: none;
  transition: color 0.3s ease;
}

a:hover {
  color: #2980b9;
  text-decoration: underline;
}
</style>